import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/es/storage";
import campgroundLayerReducer from "./slices/campgroundLayer";
import campgroundSearchReducer from "./slices/campgroundSearch";
import hoveredCampgroundReducer from "./slices/hoveredCampground";
import mapChoreographyReducer from "./slices/mapChoreography";
import mapSettingsReducer from "./slices/mapSettings";
import mapTooltipReducer from "./slices/mapTooltip";
import publicLandsLayerReducer from "./slices/publicLandsLayer";
import weatherLayerReducer from "./slices/weatherLayer";

// Redux persist configuration
const persistConfig = {
  key: "iwannacamp-root",
  storage,
  whitelist: ["publicLandsLayer", "mapSettings", "campgroundLayer", "weatherLayer"], // Only persist these slices
};

// Combine reducers
const rootReducer = {
  campgroundSearch: campgroundSearchReducer,
  hoveredCampground: hoveredCampgroundReducer,
  publicLandsLayer: publicLandsLayerReducer,
  mapChoreography: mapChoreographyReducer,
  mapSettings: mapSettingsReducer,
  campgroundLayer: campgroundLayerReducer,
  weatherLayer: weatherLayerReducer,
  mapTooltip: mapTooltipReducer,
};

// Create persisted reducer
const persistedReducer = persistReducer(
  persistConfig,
  (state: any, action: any) => {
    const newState: any = {};
    for (const key in rootReducer) {
      // @ts-ignore
      newState[key] = rootReducer[key](state?.[key], action);
    }
    return newState;
  }
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: {
    actionsDenylist: ["campgroundSearch/setHoveredCampground"],
  },
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
